export default __webpack_public_path__ + "img/survey.9c6f287c.svg";